<app-top-bar></app-top-bar>

<div class="app-container">
  <router-outlet></router-outlet>
</div>
<div class="alert alert-info">
  In compliance with the Jeanne Clery Act, the University of Florida maintains the Crime Log and Fire Log as informative documents to record criminal incidents
  and fires within residential housing reported to the University of Florida. Criminal incidents will be recorded within two business days of receipt of a criminal incident,
  unless there is evidence that it would otherwise impede an ongoing investigation or jeopardize the safety of an individual.
  Fires will be recorded within two business days of receipt of a fire occurring. Incident dispositions or criminal classifications are updated within 60 days of the incident being
  recorded on the Crime or Fire Log; as such, an incident disposition may change after the 60 days and that change will not be reflected.
  If you would like to request entries older than 60 days, please submit a request through UF Public Records: <a style="text-decoration: underline  ;" target="_blank" aria-label="link to uf publicrecords" src="http://publicrecords.ufl.edu">publicrecords.ufl.edu</a>
</div>
<footer class="footer-big">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <h4>RESOURCES</h4>
        <ul>
          <li><a href="http://gemru.org/">GEMRU</a></li>
          <li><a href="http://publicsafety.ufl.edu/gatorsafe.html">GatorSafe App</a></li>
          <li><a href="https://publicsafety.ufl.edu/clery/">Clery Act</a></li>
          <li><a href="https://ufalert.ufl.edu/">UF Alert</a></li>
        </ul>
      </div>
      <div class="col-md-3"></div>
      <div class="col-md-5">
        <a href="http://www.ufl.edu">
          <img
            src="/clery/assets/ufwhite_full.png"
            alt="UF Logo"
            class="img-fluid"
            target="_blank"
          />
        </a>
        <address class="mt-3 mb-0">
          <h4 class="sr-only">Address</h4>
          University of Florida <br />
          Gainesville, FL 32611 <br />
          <strong>UF Operator: (352) 392-3261</strong> <br />
        </address>
      </div>
    </div>
  </div>
</footer>
